import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-calendar-skeleton-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="skeleton-calendar-container">
    
    <!-- Week view skeleton -->
    <div class="skeleton-week-view">
      <!-- Day headers -->
      <div class="skeleton-days-header">
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
        <div class="skeleton-day-header">
          <div class="skeleton-day-name"></div>
          <div class="skeleton-day-date"></div>
        </div>
      </div>
      
      <!-- Time slots and events -->
      <div class="skeleton-time-grid">
        <!-- Time labels -->
        <div class="skeleton-time-labels">
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
          <div class="skeleton-time-label">
            <div class="skeleton-time-text"></div>
          </div>
        </div>
        
        <!-- Calendar grid -->
        <div class="skeleton-grid">
          <!-- Calendar events (random placement) -->
          <div class="skeleton-event skeleton-event-1"></div>
          <div class="skeleton-event skeleton-event-2"></div>
          <div class="skeleton-event skeleton-event-3"></div>
          <div class="skeleton-event skeleton-event-4"></div>
          <div class="skeleton-event skeleton-event-5"></div>
          
          <!-- Grid lines -->
          <div class="skeleton-grid-lines">
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
            <div class="skeleton-grid-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .skeleton-calendar-container {
      width: 100%;
      margin:20px;
      height: 70vh;
      display: flex;
      flex-direction: column;
      background-color: var(--skeleton-bg-primary);
      overflow: hidden;
      border: 1px solid var(--skeleton-border-color);
      border-radius: 8px;
    }
    
    .skeleton-week-view {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
    }
    
    .skeleton-days-header {
      display: flex;
      border-bottom: 1px solid var(--skeleton-border-color);
      height: 60px;
    }

    .skeleton-day-header {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-right: 1px solid var(--skeleton-border-color);
      padding: 8px;
    }

    .skeleton-day-name {
      width: 80px;
      height: 20px;
      margin-bottom: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
      border-radius: 4px;
    }

    .skeleton-day-date {
      width: 30px;
      height: 16px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
      border-radius: 4px;
    }

    .skeleton-time-grid {
      flex: 1;
      display: flex;
      position: relative;
      overflow: hidden;
    }

    .skeleton-time-labels {
      width: 60px;
      display: flex;
      flex-direction: column;
      border-right: 1px solid var(--skeleton-border-color);
    }

    .skeleton-time-label {
      height: 7.14%; /* 100% / 14 time slots */
      display: flex;
      align-items: flex-start;
      padding-top: 8px;
      padding-right: 8px;
      justify-content: flex-end;
    }

    .skeleton-time-text {
      width: 35px;
      height: 16px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
      border-radius: 2px;
    }

    .skeleton-grid {
      flex: 1;
      position: relative;
    }

    .skeleton-grid-lines {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
    }

    .skeleton-grid-line {
      position: relative;
      height: 7.14%; /* 100% / 14 time slots */
      border-bottom: 1px solid var(--skeleton-border-color);
    }

    .skeleton-event {
      position: absolute;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-event-from) 25%, var(--skeleton-event-mid) 50%, var(--skeleton-event-to) 75%);
      background-size: 200% 100%;
      box-shadow: var(--skeleton-shadow);
      height: 40px;
      padding: 4px 8px;
    }
    
    .skeleton-event-1 {
      top: 13%;
      left: 5%;
      width: 12%;
      height: 30px;
    }
    
    .skeleton-event-2 {
      top: 25%;
      left: 83%;
      width: 12%;
      height: 60px;
    }
    
    .skeleton-event-3 {
      top: 45%;
      left: 19%;
      width: 12%;
      height: 30px;
    }
    
    .skeleton-event-4 {
      top: 38%;
      left: 65%;
      width: 12%;
      height: 45px;
    }
    
    .skeleton-event-5 {
      top: 60%;
      left: 45%;
      width: 12%;
      height: 30px;
    }
    
    /* Shimmer animation effect */
    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }

    /* Staggered animations */
    .skeleton-event-1 { animation-delay: 0.1s; }
    .skeleton-event-2 { animation-delay: 0.2s; }
    .skeleton-event-3 { animation-delay: 0.3s; }
    .skeleton-event-4 { animation-delay: 0.4s; }
    .skeleton-event-5 { animation-delay: 0.5s; }
  `]
})
export class CalendarSkeletonLoaderComponent {}